interface Props {
  color?: string
  width?: number
  height?: number
}

export const DownloadIconNew = ({ color = '#6F6F6F', width = 20, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1211 9.31055C19.3971 9.31077 19.6211 9.53454 19.6211 9.81055V19.1211C19.621 19.397 19.397 19.6209 19.1211 19.6211H0.5C0.224016 19.621 0.000109336 19.3971 0 19.1211V9.81445C0.000209122 9.53856 0.224078 9.31456 0.5 9.31445C0.776013 9.31445 0.999791 9.53849 1 9.81445V18.6211H18.6211V9.81055C18.6211 9.53447 18.845 9.31065 19.1211 9.31055ZM9.80664 0C10.0827 7.41605e-05 10.3065 0.223988 10.3066 0.5V13.2627L14.1123 9.45703C14.3076 9.26192 14.6241 9.26182 14.8193 9.45703C15.0145 9.65225 15.0144 9.96881 14.8193 10.1641L10.1641 14.8193C9.99322 14.9901 9.72919 15.0119 9.53516 14.8838L9.45703 14.8193L4.80176 10.1641C4.60658 9.96883 4.60661 9.65228 4.80176 9.45703C4.99701 9.26184 5.31354 9.26184 5.50879 9.45703L9.30664 13.2549V0.5C9.30674 0.223942 9.53056 0 9.80664 0Z"
        fill={color}
      />
    </svg>
  )
}
